<script setup>
const props = defineProps({
  notification: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['click'])

const iconMap = {
  promotion: { icon: 'material-symbols:real-estate-agent', color: 'text-blue-500', bg: 'bg-blue-50' },
  quote: { icon: 'material-symbols:description', color: 'text-orange-500', bg: 'bg-orange-50' },
  message: { icon: 'material-symbols:chat', color: 'text-green-500', bg: 'bg-green-50' },
  invitation: { icon: 'material-symbols:mail', color: 'text-purple-500', bg: 'bg-purple-50' },
  budget: { icon: 'material-symbols:account-balance-wallet', color: 'text-cyan-500', bg: 'bg-cyan-50' },
  company: { icon: 'material-symbols:account-balance', color: 'text-indigo-500', bg: 'bg-indigo-50' },
  system: { icon: 'material-symbols:info', color: 'text-gray-500', bg: 'bg-gray-50' }
}

const iconConfig = computed(() => iconMap[props.notification.type] || iconMap.system)

const timeAgo = computed(() => {
  const dayjs = useDayjs()
  return dayjs(props.notification.createdAt).fromNow()
})

function handleClick() {
  emit('click', props.notification)
}
</script>

<template>
  <div
    class="flex gap-3 px-4 py-3 border-b border-slate-50 last:border-b-0 cursor-pointer transition-colors hover:bg-slate-50"
    :class="{ 'bg-blue-50/50': !notification.isReaded }"
    @click="handleClick"
  >
    <div
      class="flex-shrink-0 size-10 rounded-full flex items-center justify-center"
      :class="iconConfig.bg"
    >
      <Icon :name="iconConfig.icon" class="text-lg" :class="iconConfig.color" />
    </div>

    <div class="flex-1 min-w-0">
      <div class="flex items-start justify-between gap-2">
        <p
          class="text-sm font-medium text-slate-800 truncate"
          :class="{ 'font-semibold': !notification.isReaded }"
        >
          {{ notification.title }}
        </p>
        <span
          v-if="!notification.isReaded"
          class="flex-shrink-0 size-2 bg-blue-500 rounded-full mt-1.5"
        />
      </div>
      <p class="text-xs text-slate-500 mt-0.5 line-clamp-2">
        {{ notification.message }}
      </p>
      <div class="mt-1 flex items-center gap-2">
        <span
          v-if="notification.promotion?.name"
          class="inline-flex min-w-0 items-center gap-1 rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-semibold text-slate-600"
        >
          <Icon name="material-symbols:real-estate-agent" class="shrink-0 text-xs" />
          <span class="truncate">{{ notification.promotion.name }}</span>
        </span>
        <p class="text-xs text-slate-400">
          {{ timeAgo }}
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
